(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ActiveOn', [
            'MW.ContactManager.ActiveOnRow',
            'MW.ContactManager.ActiveOnEmptyRow',
            'MW.ContactManager.ContactManagerNavigationService'
        ])
        .directive('activeOn', function () {
            return {
                restrict: 'E',
                templateUrl: 'icm-web/views/partials/active_on',
                scope: {
                    contactId: '@',
                    activeOnModel: '=?',
                    contact: '=?'
                },
                controller: ActiveOnController,
                controllerAs: 'activeOnController'
            };
        })
        .controller('ActiveOnController', [
            'ContactManagerNavigationService',
            '$scope',
            ActiveOnController
        ]);

    function ActiveOnController(ContactManagerNavigationService, $scope) {
        this.id = $scope.contactId;
        this.accounts = $scope.contact.channels;
        this.contact = $scope.contact;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.isEmptyAccount = (0 === this.accounts.length) ? true : false;
    }

    ActiveOnController.prototype.editContact = function editContact() {
        this.ContactManagerNavigationService.goToEdit(this.id);
    };
}());
